import React from 'react';
import ObjectExportFilter from '../component/ObjectExportFilter';
import ExportHistory from '../component/ExportHistory';

const ObjectExport = () => (
  <React.Fragment>
    <ObjectExportFilter />
    <ExportHistory />
  </React.Fragment>
);

export default ObjectExport;



// WEBPACK FOOTER //
// ./src/views/Setup/ObjectExport/container/index.jsx